import App from 'app/app.js';
import 'app/directive/LtEnlargeLookDrawerCtrl.js';

function LtEnlargeLookDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&'
    },
    template:
      '<div id="enlarge-look-drawer" class="bottom-drawer look-enlarge-drawer" ng-init="enlargeLookDrawer.init()" lt-drawer="enlargeLookDrawer.visible" lt-drawer-cancellation="enlargeLookDrawer.cancel()" >' +
      '   <div id="most-popular-cont">' +
      '       <h5 class="text-center" lt-translate="PORTRAIT_LOOK_NUMBER" lt-translate-values="{lookNumber: enlargeLookDrawer.look.lookNumber}"> </h5>' +
      '       <div class="row">' +
      '           <div class="col-xs-12">' +
      '               <img lt-image-orientation-class lt-look-loader="enlargeLookDrawer.look" class="photo should-stay-blocked">' +
      '           </div>' +
      '       </div>' +
      '       <div align="center" class="row cancel-link-pad">' +
      '           <div class="cancelSprite">' +
      '               <a id="enlarge-look-close" ng-click="enlargeLookDrawer.close()" lt-translate="PORTRAIT_LOOK_CLOSE"></a>' +
      '           </div>' +
      '       </div>' +
      '   </div>' +
      '</div>',
    controller: 'LtEnlargeLookDrawerCtrl',
    controllerAs: 'enlargeLookDrawer'
  };
}

App.directive('ltEnlargeLookDrawer', [LtEnlargeLookDrawerDirective]);
